module.exports = __webpack_public_path__ + "static/media/img_follow_up_null.7d9549bd.svg";